import React, { useEffect } from "react";
import Header from "parts/Header";
import Footer from "parts/Footer";

export default function ThankYou(props) {
  useEffect(() => {
    // Confetti animation
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/npm/canvas-confetti@1.4.0/dist/confetti.browser.min.js";
    script.async = true;
    script.onload = () => {
      window.confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
      });
    };
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <Header {...props} />
      <div className="min-h-screen flex flex-col justify-center items-center bg-green-50 p-8">
        <div className="bg-white p-10 rounded-3xl shadow-2xl text-center max-w-xl w-full animate__animated animate__fadeIn">
          <h1 className="text-4xl font-extrabold text-green-600 mb-4">
            🎉 Thank You!
          </h1>
          <p className="text-gray-700 text-lg mb-6">
            Your request has been received and payment completed.
            <br />
            We’ll start working on your project shortly!
          </p>
          <p className="text-gray-500 mb-8">
            A confirmation email has been sent to your inbox.
          </p>
          <a
            href="/"
            className="inline-block px-8 py-3 bg-green-500 hover:bg-green-600 text-white rounded-full font-semibold transition-all duration-300"
          >
            Return Home
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
}
